import { configureRequest } from "@asosteam/asos-web-request";
import configureLogger from "asos-web-logging";
const logger = configureLogger({
    moduleName: "get-ugc-data-client-side",
    maxLogLevel: "info",
});
export const requestHelper = configureRequest({
    defaultTimeout: 10000,
    retries: 2,
    retryDelay: () => 500,
    logger,
    client: {
        name: "asos-web-content-pages",
        version: "1.0.0",
        platform: "Web",
    },
});
